<script lang="ts">
    import { _ } from "svelte-i18n"
    import { fly } from "svelte/transition"
    import { clickOutside } from "../../utils"
    import { login, dealerLoginOverlay, postLogin, postLogout, type LoginError } from "../../store"
    import FormInputText from "../widgets/FormInputText.svelte"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import { mdiClose } from "@mdi/js"
    import Icon from "../widgets/Icon.svelte"
    import { einfoApiUrl } from "../../../../api/hooks/config-client"

    let loading = false
    let error: any
    let invalid = false
    let noOrderPermission = false

    let _dealerLogin = {
        number: "",
        pass: "",
    }
    let mfaToken = ""
    let mfaCode = ""

    const doLogin = async () => {
        loading = true
        invalid = false
        error = undefined
        noOrderPermission = false
        try {
            // login via einfo account
            const l = await postLogin({ username: _dealerLogin.number, password: _dealerLogin.pass, mfaToken, mfaCode })
            typeof window !== "undefined" &&
                window.setTimeout(() => {
                    $dealerLoginOverlay = false
                    window.location.reload()
                }, 500)
            _dealerLogin.number = ""
            _dealerLogin.pass = ""
            mfaToken = ""
        } catch (e: unknown) {
            const loginError = e as LoginError
            if (loginError.type == "no_order_permission") {
                noOrderPermission = true
                _dealerLogin.number = ""
                _dealerLogin.pass = ""
                mfaToken = ""
            } else if (loginError.type == "mfa") {
                // mfa required
                _dealerLogin.number = ""
                _dealerLogin.pass = ""
                mfaToken = loginError.data?.mfaToken
            } else {
                invalid = true
                error = e
                mfaToken = ""
            }
            console.log(e)
        }
        loading = false
    }
</script>

<div
    class="accountoverlay"
    transition:fly="{{ x: 1000 }}"
    use:clickOutside="{(target) => {
        if (!document.getElementById('dealerLoginIconLink').contains(target)) $dealerLoginOverlay = false
    }}"
>
    <!-- svelte-ignore a11y-invalid-attribute -->
    <a
        class="closer"
        href=""
        on:click|preventDefault="{() => {
            $dealerLoginOverlay = false
        }}"
    >
        <Icon path="{mdiClose}" size="24px" />
    </a>

    <div class="pad">
        <div class="headline">{$_("dealer-login.headline")}</div>

        {#if $login}
            <p>
                {@html $_("dealer-login.logged-in-info-html", {
                    values: {
                        number: $login?.account?.ident?.dealerNumber + "-" + $login?.account?.ident?.personNumber,
                    },
                })}
            </p>
            <button
                class="btn btn-secondary"
                on:click="{() => {
                    postLogout()
                        .then(() => {
                            window.setTimeout(() => {
                                $dealerLoginOverlay = false
                                // window.location.reload()
                            }, 500)
                        })
                        .catch((e) => {
                            console.error(e)
                        })
                }}">{$_("dealer-login.logout")}</button
            >
        {:else}
            <form
                on:submit|preventDefault="{() => {
                    doLogin()
                }}"
            >
                {#if mfaToken}
                    <p>{$_("dealer-login.mfa-info")}</p>
                    <FormInputText
                        type="text"
                        name="mfaCode"
                        placeholder="{$_('dealer-login.mfa-code')}"
                        bind:value="{mfaCode}"
                        required
                    />
                {:else}
                    <FormInputText
                        type="text"
                        name="number"
                        placeholder="{$_('dealer-login.dealer-number')}"
                        bind:value="{_dealerLogin.number}"
                        required
                    />
                    <FormInputText
                        name="password"
                        placeholder="{$_('dealer-login.password')}"
                        bind:value="{_dealerLogin.pass}"
                        type="password"
                        required
                        class="sentry-mask"
                    />
                {/if}

                {#if noOrderPermission}
                    <!-- TODO translate -->
                    <p style="color: var(--error)">Sie haben mit diesem Login keine Berechtigung für den Shop.</p>
                {:else}
                    {#if error}
                        <p style="color: var(--error);">
                            {$_("dealer-login.error")}
                        </p>
                    {/if}

                    {#if invalid}
                        <p style="color: var(--error)">{$_("dealer-login.invalid-login")}</p>
                    {/if}
                {/if}

                {#if loading}
                    <MiniLoader />
                {:else}
                    <div class="row">
                        <div class="col-md-6">
                            <a href="{einfoApiUrl.replace(/api.*$/, '')}/de/account-pw-reset" target="_blank"
                                >{$_("dealer-login.forgot-password")}</a
                            >
                        </div>
                        <div class="col-md-6" style="text-align: right;">
                            <button class="btn btn-secondary" type="submit">{$_("dealer-login.login")}</button>
                        </div>
                    </div>
                {/if}
            </form>

            <!-- TODO translate -->
            <br />
            <div class="headline">Achtung!</div>
            <p>
                Der Login mit Händlernummer und Postleitzahl wurde aus Sicherheitsgründen entfernt.<br />
                <br />
                Um als Händler zu bestellen, verwenden Sie bitte Ihre eInfo Login-Daten.<br />
                <br />
            </p>
            <div class="headline">Sie haben noch keinen eInfo Zugang?</div>
            <p>
                Benutzen Sie das folgende Portal um sich zu registrieren:
                <br />
                Zur
                <a href="{einfoApiUrl.replace(/api.*$/, '')}/de/account-request?ref=eShop" target="_blank"
                    >&raquo;eInfo-Registrierung</a
                ><br />
                <br />
            </p>
            <p>
                {@html $_("dealer-login.problem-contact-html")}
            </p>
        {/if}
    </div>
</div>

<style lang="less">
    @import "../../css/variables.less";
    .accountoverlay :global {
        .pad {
            padding: 50px;
        }
        position: fixed;
        bottom: 0;
        left: initial;
        right: 0;
        width: 100vw;
        top: 0px;
        overflow-y: scroll;
        overflow-x: hidden;
        z-index: 2000;
        background: var(--surface);
        color: var(--on-surface);

        .closer {
            background: var(--background);
            color: var(--on-background);
            .flex();
            align-items: center;
            border-bottom: 1px solid var(--border-color-default);
            padding: 3px 20px;
            margin-bottom: 20px;
            font-size: 18px;
            height: 65px;
        }
        form {
            margin-bottom: 20px;
        }
        .headline {
            font-weight: 800;
            margin-bottom: 20px;
        }
        @media @desktop {
            width: 50vw;
            border-left: 1px solid var(--border-color-default);
            overflow-y: auto;
        }
        @media @desktop_large {
            width: 30vw;
        }
    }
</style>
